import { cn } from '@/lib/utils';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Soft lift + shadow on hover (marketing cards) */
  hover?: boolean;
}

export function Card({ children, className, hover = false, ...props }: CardProps) {
  return (
    <div
      className={cn(
        'bg-white backdrop-blur-sm border border-gray-200/80 rounded-2xl p-6 shadow-sm',
        hover &&
          'transition-all duration-300 ease-out hover:-translate-y-1.5 hover:shadow-lg hover:border-accent/40',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
